<template>
    <v-container class="py-0">
        <v-row class="row-company-img">
            <v-col
                class="py-0 company-img-container"
                cols="4">
                <div class="company-img">
                    <img
                        class="img-profile"
                        :src="$store.state.companyProfileImg">
                    <span
                        v-if="showIcon"
                        @click="goToSetting()"
                        class="setting-container">
                        <i class="setting-icon fas fa-cog"></i>
                    </span>
                </div>
            </v-col>
            <v-col
                class="py-0"
                cols="8">
                <v-select
                    v-model="selectedBranchId"
                    @change="changeBranch"
                    item-text="name"
                    item-value="id"
                    :items="$store.state.branches"
                    placeholder=" ">
                </v-select>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import permissionConstant from '@/constants/permissions.js'
export default {
    name: 'BranchSelect',

    data () {
        return {
            selectedBranchId: null,
            showIcon: false,
            userPermissionList: [],
            permissionCompanySetting: [
                permissionConstant.company.view,
                permissionConstant.branch.view,
                permissionConstant.department.view,
                permissionConstant.companyHoliday.view,
                permissionConstant.lineService.update,
                permissionConstant.userManagement.superAdmin.view,
                permissionConstant.userManagement.admin.view,
                permissionConstant.userManagement.hr.view
            ]
        }
    },

    methods: {
        async getBranchs () {
            await this.$store.dispatch('getBranches')
            this.selectedBranchId = parseInt(localStorage.getItem('currentBranchId'))
        },

        goToSetting () {
            this.$emit('clear-sidebar')
            this.$router.push({ name: 'CompanySetting' }, () => {})
        },

        changeBranch (branchId) {
            if (this.$store.state.branches) {
                const currentBranch = this.$store.state.branches.find((branch) => branch.id === branchId)
                this.$store.dispatch('setCurrentBranch', currentBranch)
                this.selectedBranchId = parseInt(localStorage.getItem('currentBranchId'))
                this.$emit('select-sidebar', 'dashboard')
                this.$router.push({ name: 'Dashboard' }, () => {})
                this.$forceUpdate()
            }
        },
        checkPermission () {
            this.showIcon = this.permissionCompanySetting.some(p => this.userPermissionList.includes(p))
        }
    },

    async mounted () {
        await this.getBranchs()
        await this.$store.dispatch('getCompanyProfileImg')
        this.userPermissionList = this.$store.state.permissions
        this.checkPermission()
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-input__slot:before {
    display: none;
}
.company-img-container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    background-clip: content-box;
    background-color: white;
    height: 54px;
    border-radius: 0.79rem;
}
.row-company-img {
    padding: 0rem 0.7rem;
}

.img-profile {
    width: 52px;
    max-height: 54px;
    display: flex;
}
.setting-container {
    background: #d76436;
    position: absolute;
    height: 23px;
    width: 23px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    border-radius: 1.25rem;
    margin-left: 3rem;
    cursor: pointer;
    top: 116px;
}
.setting-icon {
    color: white;
    font-size: 13px;
}
</style>
